<template>
  <div class="project">
    <h3 class="title">
      <router-link :to="`/projects/${project.id}`">{{
        project.name
      }}</router-link>
    </h3>
    <div class="project__details">
      <div>Description: {{ project.desc }}</div>
      <div>
        Idea: <a :href="project.source" target="_blank">{{ project.idea }}</a>
      </div>
      <div class="project__details__buttons">
        <a :href="project.git" target="_blank"
          ><button class="git">git</button></a
        >
        <router-link :to="`/projects/${project.id}`"
          ><button class="next">galeria</button></router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['project'],
  setup(props) {},
};
</script>

<style lang="scss">
.project {
  border-image: url('data:image/svg+xml;utf8,<?xml version="1.0" encoding="UTF-8" ?><svg version="1.1" width="5" height="5" xmlns="http://www.w3.org/2000/svg"><path d="M2 1 h1 v1 h-1 z M1 2 h1 v1 h-1 z M3 2 h1 v1 h-1 z M2 3 h1 v1 h-1 z" fill="rgb(33,37,41)" /></svg>');
  border-image-repeat: space;
  border-image-slice: 2;
  border-image-width: 2;
  border-image-outset: 2;
  border-style: solid;
  border-width: 4px;
  box-shadow: 4px 8px black, 0 0 black, 8px 4px black, 0 0 black;

  & .title {
    display: table;
    padding: 0 1rem;
    margin: -1.8rem 5rem 1rem;
    font-size: 1.5rem;
    background-color: #fff;
    text-transform: uppercase;
    font-size: 1.2rem;
  }

  a {
    cursor: pointer;
  }

  &__details {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    &__buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 2rem;
      gap: 2rem;
      color: #fff;

      button {
        width: 10rem;
        text-align: center;
        transition: all 0.3s ease-out;

        &:hover {
          transform: translateY(-3px);
        }

        &:active {
          transform: translateY(-1px);
        }
      }

      .git {
        background-color: var(--bg-color-git);
        box-shadow: 0 0.5em var(--bg-color-git), 0 -0.5em var(--bg-color-git),
          0.5em 0 var(--bg-color-git), -0.5em 0 var(--bg-color-git);
      }
      .next {
        background-color: var(--bg-color-more);
        box-shadow: 0 0.5em var(--bg-color-more), 0 -0.5em var(--bg-color-more),
          0.5em 0 var(--bg-color-more), -0.5em 0 var(--bg-color-more);
      }
    }
  }
}
</style>
